import { Route, Switch } from 'react-router-dom';

import AuthorizedRoute from 'views/components/authorized-route';
import PrivateRoute from 'views/components/private-route';
import PublicRoute from 'views/components/public-route';
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';

const RouteWithSubRoutes = ({
  component: Component,
  exact,
  path,
  routes,
  privated,
  published,
  permissions,
  store,
  ...rest
}) => {
  let RouterFinal = Route;
  // A route that names permissions sits inside the private subtree already, so
  // the session is a given by the time this runs — only the role is in question.
  if (permissions) {
    RouterFinal = AuthorizedRoute;
  }
  if (privated) {
    RouterFinal = PrivateRoute;
  }
  if (published) {
    RouterFinal = PublicRoute;
  }

  if (routes) {
    return (
      <RouterFinal
        exact={exact}
        path={path}
        permissions={permissions}
        render={(routeProps) => (
          <Component {...routeProps} {...rest}>
            <Switch>
              {routes.map((route) => (
                <RouteWithSubRoutes key={route.path} store={store} {...route} />
              ))}
            </Switch>
          </Component>
        )}
      />
    );
  }

  return (
    <RouterFinal
      exact={exact}
      path={path}
      permissions={permissions}
      render={(routeProps) => <Component {...routeProps} {...rest} />}
    />
  );
};

const RouteConfig = ({ routes, store }) => (
  <Switch>
    {routes.map((route) => (
      <RouteWithSubRoutes key={route.path} store={store} {...route} />
    ))}
  </Switch>
);

export default RouteConfig;
